import { HeadingNode, TextAlignment } from '@prezly/story-content-format';

export function getHeaderAlignment(
    nodes: { children: HeadingNode[] } | HeadingNode[],
): `${TextAlignment}` | undefined {
    const headingNodes = Array.isArray(nodes) ? nodes : nodes.children;

    const titleNode = headingNodes.find((node) => HeadingNode.isTitleHeadingNode(node));
    const subtitleNode = headingNodes.find((node) => HeadingNode.isSubtitleHeadingNode(node));

    return subtitleNode?.align ?? titleNode?.align ?? TextAlignment.LEFT;
}
